import React, {
  FC, useEffect,
} from 'react';
import { v4 as uuid } from 'uuid';
import { RowLeft } from '../Styles';
import { callService } from '../../../../../assets/base64Images/ai/callService';
import { updateFoodifoxData } from '../../../../../lib/axios/FoodifoxDataAPI';
import OptionButton from '../components/Button/OptionButton';
import { getCabId32Str, getWindowWidth, lang } from '../../../../../lib/utils/utils';
import LeftToRight from '../components/Animation/LeftToRight';
import RobotReply from '../components/Reply/RobotReply';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';

/**
 * 电话联系客服
 */
const Q18: FC<Props> = ({
  cabId,
  addElement,
  h5Platform,
  deviceCode,
  sessionId,
}) => {
  const option = { zhValue: '重新开始', enValue: 'Start over' };
  const [saveCallLog] = updateFoodifoxData('/foxH5RentLog/saveCallServiceLog');

  useEffect(() => {
    // 流程ID
    const flowId = uuid();
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ alignItems: 'center' }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.55, getWindowWidth() * 0.58) }}
            langZh={(
              <>
                抱歉，出于安全考虑，请您拨打我们的人工服务热线 <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>1300 359 889</span> <span style={{ fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600 }}>（工作日早上9:00 至 下午5:00）</span>
              </>
            )}
            langEn={(
              <>
                For security reasons call <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>1300 359 889</span> Available <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>Weekdays 9:00am - 5:00pm</span>.
              </>
            )}
          />
          <img
            src={callService}
            style={{ width: 41, height: 41, marginLeft: 20 }}
            onClick={() => {
              addSystemLog(cabId, deviceCode, h5Platform + '', 'Q18 - user: call service', sessionId);
              location.href = 'tel:1300359889';
              saveCallLog({
                param: {
                  cabId: getCabId32Str(cabId),
                  telNumber: '1300359889',
                },
              });
            }}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q18 - bot: There is something wrong, please try again. If you need further help, please call us 1300 359 889 for human support between Weekdays 9:00am - 5:00pm', sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          <RowLeft>
            <OptionButton
              langZh={option.zhValue}
              langEn={option.enValue}
              callback={() => {
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q18 - user: ' + option.enValue, sessionId);
                addElement([]);
              }}
            />
          </RowLeft>
        </LeftToRight>
      );
    }, 400);
  }, []);

  return (
    <></>
  );
};

export interface Props {
  cabId: number;
  addElement: (elements: any) => void;
  deviceCode: string;
  h5Platform: number;
  sessionId: string;
}

export default Q18;
